export function getSendMailEndpoint(): string {
    return `/request/send`;
}

export function getSendFinanceSimulationMailEndpoint(destination: string): string {
    return `/request/send/finance-simulation/${destination}`;
}
